module.exports = __webpack_public_path__ + "assets/img/21_64.c9925cc5.jpg";